const RatingStatus = {
  1: 'Could be better',
  2: 'Not Bad',
  3: 'Good',
  4: 'Great',
  5: 'Amazing',
};

export default RatingStatus;
